import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import calendarUtils from 'utils/calendar';
import * as optimizelyUtil from 'utils/optimizely';
import { dayInMilliseconds } from 'utils/utils';
import dates from 'utils/dates';
import BookSelect from 'components/BookSelect/BookSelect';

export default class CalendarMonthSelect extends Component {
  static propTypes = {
    annualAvailability: ImmutablePropTypes.map.isRequired,
    availabilityType: PropTypes.string,
    baseState: ImmutablePropTypes.map.isRequired,
    onClickDate: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    availabilityType: 'dp',
    disabled: false,
  };

  onMonthChange = (event) => {
    const { onClickDate } = this.props;
    optimizelyUtil.fireEvent('CalendarMonthSelect', 'clicked');
    onClickDate(event.currentTarget.value);
  };

  getCheapestDayOfMonth(monthObj) {
    return monthObj.reduce((cheapest, price, day) => {
      const isCheaper = !cheapest.price || price < cheapest.price;
      return isCheaper ? { price, day } : cheapest;
    }, {}).day;
  }

  // taken from PandaCalendar
  get currentMonthIndex() {
    const availableMonthsCollection = this.getAvailableMonthsCollection();
    return availableMonthsCollection.findIndex(element => !!element.checked);
  }

  // taken from PandaCalendar
  getAvailableMonthsCollection() {
    const {
      annualAvailability,
      baseState,
      availabilityType,
    } = this.props;

    const hotelOnlyAvailability = annualAvailability.get(availabilityType, Immutable.Map());
    const yearKeys = hotelOnlyAvailability.keySeq().toArray();
    const calDateFromBaseState = calendarUtils.getDepartureDate(baseState, true) * dayInMilliseconds;
    const calDateMonthAndYearText = dates.format(calDateFromBaseState, 'MMMM YYYY');

    let availableMonthsCollection = [];
    yearKeys.sort().map((year) => {
      const yearObj = hotelOnlyAvailability.get(`${year}`, Immutable.List());

      if (yearObj.size) {
        yearObj.map((item, monthNum) => {
          if (item) {
            const cheapestDayOfMonth = this.getCheapestDayOfMonth(item);
            const cheapestOfMonthDate = new Date(Date.UTC(year, monthNum, cheapestDayOfMonth));
            const calDate = cheapestOfMonthDate.getTime() / dayInMilliseconds;
            const monthAndYearText = dates.format(cheapestOfMonthDate, 'MMMM YYYY');

            availableMonthsCollection.push({
              label: monthAndYearText,
              value: calDate,
              checked: monthAndYearText === calDateMonthAndYearText,
            });
          }
        });
      }
    });

    const selectedMonthIsAvailable = availableMonthsCollection
      .find(month => month.label === calDateMonthAndYearText);

    // if the current month is not available, ask the user to select a new month
    if (!selectedMonthIsAvailable) {
      availableMonthsCollection = [{ label: 'Select Month' }, ...availableMonthsCollection];
    }

    return availableMonthsCollection;
  }

  render() {
    const availableMonthsCollection = this.getAvailableMonthsCollection();
    const currentMonth = availableMonthsCollection[this.currentMonthIndex] || {};

    return (
      <div className="calendar-month-select">
        <BookSelect
          onFieldChange={this.onMonthChange}
          label=""
          value={currentMonth.value}
          options={availableMonthsCollection}
          hideLabel
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CalendarMonthSelect/CalendarMonthSelect.jsx
 **/